import Clarity from '@microsoft/clarity';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

const projectId = 'sf6dxa5tgn';

Clarity.init(projectId);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

declare global {
  type DbDocument<T> = {
    id: string;
  } & T;
}
